import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { ITalent } from "../types";

interface IGetDataProps {
  pagination?: {
    pageSize?: number;
    current?: number;
  };
  token?: string;
  sector?: string | null;
  relocate?: boolean | null;
  experience?: string | null;
  gender?: string | null;
  country?: string | null;
  skills?: string | null;
  jobTitle?: string | null;
  visibilityScore?: any | null;
  assessmentStatus?: string | null;
  search?: string;
}

export const QUERY_KEY_FOR_TALENTS = "Talents";

const getTalents = async (
  props: IGetDataProps
): Promise<{ data: ITalent[]; total: number }> => {
  const { 
    pagination, 
    sector, 
    experience, 
    gender, 
    relocate, 
    country, 
    skills, 
    jobTitle, 
    visibilityScore, 
    assessmentStatus, 
    search 
  } = props;

  const url = `${END_POINT.BASE_URL}/v1/talents`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params: {
      page: pagination?.current,
      limit: pagination?.pageSize,
      sector,
      experience,
      gender,
      relocate,
      country,
      skills,
      jobTitle,
      visibilityScore,
      assessmentStatus,
      search: search,
    },
  };

  const res = await axios.get(url, config);

  const data: ITalent[] = res.data.data.map((item: ITalent) => ({ ...item }));

  return {
    data,
    total: res.data.meta.total,
  };
};

export const useFetchTalent = (props: IGetDataProps) => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_TALENTS, props],
    () =>
      getTalents({
        ...props,
        token,
      }),
    {
      keepPreviousData: false,
      staleTime: 0,
      refetchOnWindowFocus: false,
      onError: (err: any) => { },
      onSuccess: (data) => { },
    }
  );

  return queryData;
};